import React, { Component } from 'react';
import {
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TextInput,
  Button,
  FormGroup,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  TextArea,
} from 'carbon-components-react';
import { WarningModal } from '../common/WarningModal';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';

export default class EnergyAccountLeasedAssetModal extends Component {
    constructor(props) {
        super(props);
    };

    render() {
        const modalHeader = {
            title: this.props.isEditModal ? 'Edit ' : 'Add new ',
            iconDescription: 'Close',
            buttonOnClick: () => this.props.toggleModal(false),
        };

        const { title, isOpenModal } = this.props;

        return (   
            <>
            <ComposedModal
                className="light-modal"
                open={isOpenModal}
                danger="false"
                onClose={() => false}
            >
                <ModalHeader className="margin-modal" {...modalHeader}>
                    <p>{title || ''}</p>
                </ModalHeader>
                <ModalBody className="margin-modal">
                    <div className="bx--grid--full-width">  
                        <div className="bx--col-md-4 bx--col-lg-6">
                            <FormGroup legendText="Leased Asset Name*">
                            <TextInput
                                id="name"
                                name="leasedAssetName"
                                alt="Name"
                                placeholder="Input leased asset name"
                                value={this.props.editModel ? this.props.editModel.name || '' : ''}
                                onChange={(el) => this.props.onUpdateInputChange(el.target.id, el.target.value)}
                                type="text"
                                hideLabel
                                labelText=""
                                invalid={this.props.nameLeasedAssetValidation != null}
                                className="bx--text-input-left"
                            />
                            {this.props.nameLeasedAssetValidation}
                            </FormGroup>
                        </div>
                        <div className="datatable--information">
                        <DataTable
                            rows={this.props.leasedAssetRows || []}
                            headers={this.props.leasedAssetHeaders}
                            useZebraStyles
                            render={({ rows, headers, getHeaderProps, getRowProps }) => (
                            <TableContainer className="bx--grid--full-width">
                                <Table>
                                    <TableHead className="colorgray">
                                    <TableRow>
                                        {headers.map((header) => (
                                        <TableHeader
                                            className={header.type === 'bool' ? 'align-center' : ''}
                                            {...getHeaderProps({ header })}
                                        >
                                            <div> {header.header} </div>
                                        </TableHeader>
                                        ))}
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {rows == null || rows.length === 0 ? (
                                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                                    ) : (
                                        <>
                                        {rows.map((row) => (
                                            <TableRow {...getRowProps({ row })}>
                                            <td className="bx--cell">{row.cells[0].value}</td>
                                            <td className="bx--cell center-vertically">{row.cells[1].value}</td>
                                            <td className="bx--cell center-vertically right-align">
                                                {Math.round(row.cells[2].value * 100) / 100}
                                            </td>
                                            {row.cells.slice(3).map((cell) => (
                                                <td className="bx--cell-input" key={cell.id}>
                                                <TextInput
                                                    className="cell--item"
                                                    value={this.props.leasedAssetMatrix ? this.props.leasedAssetMatrix[row.id][cell.info.header] : '0'}
                                                    onChange={(e) => this.props.onRowColInputChange(row.id, cell.info.header, e )}
                                                    type="number"
                                                    min="0"
                                                    invalid={ this.props.leasedAssetValidations[row.id][cell.info.header] != null }
                                                />
                                                {this.props.leasedAssetValidations[row.id][cell.info.header]}
                                                </td>
                                            ))}
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <td colSpan={10} className="bx--cell grand-total">
                                            <h4>
                                                Total:
                                                {Math.round(this.props.grandTotal * 100) / 100}
                                            </h4>
                                            </td>
                                        </TableRow>
                                        </>
                                    )}
                                    </TableBody>
                                </Table>

                            </TableContainer>
                            )}
                        />
                        </div>
                        <div className="datatable--information">
                        <DataTable
                            rows={this.props.leasedAssetInformativeRows || []}
                            headers={this.props.leasedAssetInformativeHeaders}
                            useZebraStyles
                            render={({ rows, headers, getHeaderProps, getRowProps }) => (
                            <TableContainer className="bx--grid--full-width">
                                <Table>
                                    <TableHead className="colorgray">
                                    <TableRow>
                                        {headers.map((header) => (
                                        <TableHeader
                                            className={header.type === 'bool' ? 'align-center' : ''}
                                            {...getHeaderProps({ header })}
                                        >
                                            <div> {header.header} </div>
                                        </TableHeader>
                                        ))}
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {rows == null || rows.length === 0 ? (
                                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                                    ) : (
                                        rows.map((row) => (
                                        <TableRow {...getRowProps({ row })}>
                                            <td className="bx--cell">{row.cells[0].value}</td>
                                            <td className="bx--cell center-vertically right-align">
                                            {row.cells[1].value}
                                            </td>
                                            {row.cells.slice(2).map((cell) => (
                                            <td className="bx--cell-input" key={cell.id}>
                                                <TextInput
                                                className="cell--item"
                                                value={this.props.leasedAssetMatrix ? this.props.leasedAssetMatrix[row.id][cell.info.header] : '0'}
                                                onChange={(e) => this.props.onRowColInputChange(row.id, cell.info.header, e)}
                                                type="number"
                                                min="0"
                                                invalid={ this.props.leasedAssetValidations[row.id][cell.info.header] != null }
                                                />
                                                {this.props.leasedAssetValidations[row.id][cell.info.header]}
                                            </td>
                                            ))}
                                        </TableRow>
                                        ))
                                    )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            )}
                        />
                        </div>
                        <div className="bx--col--md-12 bx--col-lg-12">
                            <FormGroup legendText='Notes'>
                            <TextArea
                                maxLength={5000}
                                id="notes"
                                placeholder="Input leased asset notes"
                                value={this.props.editModel ? this.props.editModel.notes || '' : ''}
                                onChange={(el) => this.props.onUpdateInputChange(el.target.id, el.target.value)}
                                hideLabel
                                labelText=""
                                light
                                rows={4}
                                cols={200}
                            />
                            </FormGroup>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>
                    Cancel
                </Button>
                <Button kind="primary" onClick={() => this.props.save(false)}>
                    Save
                </Button>
                </ModalFooter>
            </ComposedModal>
            {this.props.isWarningModalOpen ? (
              <WarningModal
                message="Some fields are empty. If you choose to continue, all such fields will be set to zero."
                onCancel={this.props.toggleWarningModal}
                onConfirm={this.props.handleConfirmSubmit}
              />
            ) : null}
            </>
        );
    }
}